module.exports = __webpack_public_path__ + "img/files-icon-active.96f188c5.png";